/**
 * Warning: Do not export anything from this file,
 * because that will cause errors with Jest testing-framework
 * https://stackoverflow.com/questions/39986178/testing-react-target-container-is-not-a-dom-element
 */
import React, {Fragment} from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';

import {ApolloProvider} from 'react-apollo';
import client from './apolloClient';

import LanguageProvider from './containers/LanguageProvider';
import {translationMessages} from './i18n';

import store from './store';

import App from './App';
import CookieBanner from './components/CookieBanner';
import Intercom from './services/intercom';
import ImpersonationBanner from './services/Impersonation/ImpersonationBanner';
import {IncompatibleBrowserPrompt} from './services/IncompatibleBrowserPrompt';
import RootCauseWrapper from './components/RootCauseWrapper';
import 'react-tippy/dist/tippy.css';
import './fonts.css';
import './index.css';
import './pace.css';
import './print.css';
import Toasts from './containers/Toasts';


/**
 * Render on page
 */
render(
    <Provider store={store}>
        <ApolloProvider store={store} client={client}>
            <LanguageProvider messages={translationMessages}>
                <BrowserRouter>
                    <Fragment>
                        <App/>
                        <Intercom/>
                    </Fragment>
                </BrowserRouter>
            </LanguageProvider>
        </ApolloProvider>
    </Provider>,
    document.getElementById('root')
);

render(
    <Provider store={store}>
        <LanguageProvider messages={translationMessages}>
            <Toasts/>
        </LanguageProvider>
    </Provider>,
    document.getElementById('toasts')
);

render(
    <ApolloProvider store={store} client={client}>
        <Provider store={store}>
            <LanguageProvider messages={translationMessages}>
                <ImpersonationBanner/>
            </LanguageProvider>
        </Provider>
    </ApolloProvider>,
    document.getElementById('impersonation')
);

render(
    <Provider store={store}>
        <LanguageProvider messages={translationMessages}>
            <IncompatibleBrowserPrompt window={window.navigator}/>
        </LanguageProvider>
    </Provider>,
    document.getElementById('browser-prompt')
);

render(
    <RootCauseWrapper/>,
    document.getElementById('root-cause')
);

render(
    <Provider store={store}>
        <ApolloProvider store={store} client={client}>
            <LanguageProvider messages={translationMessages}>
                <BrowserRouter>
                    <CookieBanner/>
                </BrowserRouter>
            </LanguageProvider>
        </ApolloProvider>
    </Provider>,
    document.getElementById('cookie-banner')
);
